<wdx-form-field
    [label]="formInputData?.label | translateTokenisedString"
    [isRequired]="formInputData?.isRequired"
    [isSensitive]="formInputData?.isSensitive"
    [guidanceText]="formInputData?.guidanceText | translateTokenisedString"
    [validationErrorMessage]="validationErrorMessage"
    [formGroup]="form"
>
    <div
        class="form-control p-0 overflow-hidden"
        [class.is-invalid]="validationErrorMessage"
    >
        <wdx-json-editor
            [customInputHandler]="customInputHandler"
            [customOutputHandler]="customOutputHandler"
            [readonly]="formInputData?.isReadonly || formInputData?.isDisabled"
            formControlName="jsonViewer"
            (blurred)="blurred.emit()"
        ></wdx-json-editor>
    </div>
</wdx-form-field>
